export const sceneUrls = [
  /******************************
   *        Group 1           *
   ******************************/
  {
    url: "https://prod.spline.design/dbnu9B0zY78pbNQa/scene.splinecode",
    slug: "chris-cimino",
    name: "Chris Cimino",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/st5N107NrWZRd9Ou/scene.splinecode",
    slug: "eric-hamlet",
    name: "Eric Hamlet",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/o6NP5sP94GHtoSE5/scene.splinecode",
    slug: "jason-wash",
    name: "Jason Wash",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/GdGm5MG8JUL5SEAK/scene.splinecode",
    slug: "jessica-gremmell",
    name: "Jessica Gremmell",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/dcxPWfi6zbdHOBAS/scene.splinecode",
    slug: "lauren-powers",
    name: "Lauren Powers",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/cfUFSPqYjgjSj-cP/scene.splinecode",
    slug: "pete-freeman",
    name: "Pete Freeman",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/XjWnPPXPEH54Sm3u/scene.splinecode",
    slug: "sadie-novello",
    name: "Sadie Novello",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/YgRLUDQW9mWeAeC9/scene.splinecode",
    slug: "simon-gibson",
    name: "Simon Gibson",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/YPE3nBtriNLR6Eh3/scene.splinecode",
    slug: "tianna-harvey",
    name: "Tianna Harvey",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/aVMzgzHYsbBrBbmu/scene.splinecode",
    slug: "yael-elmatad",
    name: "Yael Elmatad",
    scene: 1,
  },

  {
    url: "https://prod.spline.design/PvtC4P05PbvmmX62/scene.splinecode",
    slug: "abi-bock",
    name: "Abi Bock",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/nwb01-ZlvpuzOZqo/scene.splinecode",
    slug: "alex-hoang",
    name: "Alex Hoang",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/NTaEzKEqzL5p6QLC/scene.splinecode",
    slug: "andy-stoffo",
    name: "Andy Stoffo",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/NpTLy9L7f53sPee6/scene.splinecode",
    slug: "arielle-martorana",
    name: "Arielle Martorana",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/NpTLy9L7f53sPee6/scene.splinecode",
    slug: "audrey-beale",
    name: "Audrey Beale",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/WoicJLZfh-zqWjYY/scene.splinecode",
    slug: "jesse-ling",
    name: "Jesse Ling",
    scene: 1,
  },

  {
    url: "https://prod.spline.design/Gsc6qSm4x5C3GugT/scene.splinecode",
    slug: "justin-garbett",
    name: "Justin Garbett",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/9tXdQOXftzYejkOp/scene.splinecode",
    slug: "kati-rehbeck",
    name: "Kati Rehbeck",
    scene: 1,
  },
  {
    url: "https://prod.spline.design/U8ZxGfWzE3Ujz-D5/scene.splinecode",
    slug: "kyle-carlson",
    name: "Kyle Carlson",
    scene: 1,
  },
  /******************************
   *        Group 2           *
   ******************************/
  {
    url: "https://prod.spline.design/LTDfL1v-zWr3DjsD/scene.splinecode",
    slug: "alex-li",
    name: "Alex Li",
    scene: 2,
  },
  {
    url: "https://prod.spline.design/8FJRDgZPpYkmzDKx/scene.splinecode",
    slug: "andrei-markovits",
    name: "Andrei Markovits",
    scene: 2,
  },
  {
    url: "https://prod.spline.design/ypfXDkpaVzdxzxLI/scene.splinecode",
    slug: "ashley-chen",
    name: "Ashley Chen",
    scene: 2,
  },
  {
    url: "https://prod.spline.design/c9rmtyxInBhI7Lyd/scene.splinecode",
    slug: "brian-benns",
    name: "Brian Benns",
    scene: 2,
  },
  {
    url: "https://prod.spline.design/uv0M-eJ-ChIvs4bf/scene.splinecode",
    slug: "cam-smith",
    name: "Cam Smith",
    scene: 2,
  },
  {
    url: "https://prod.spline.design/AooXyyuadO8IHpxn/scene.splinecode",
    slug: "chris-vavra",
    name: "Chris Vavra",
    scene: 2,
  },
  {
    url: "https://prod.spline.design/xOxtzZq-Kl9AqAWt/scene.splinecode",
    slug: "danny-chang",
    name: "Danny Chang",
    scene: 2,
  },
  {
    url: "https://prod.spline.design/m3v1tVK0UEdn6gUA/scene.splinecode",
    slug: "erica-seamster",
    name: "Erica Seamster",
    scene: 2,
  },
  {
    url: "https://prod.spline.design/lJKHNy5y8JFjiGYk/scene.splinecode",
    slug: "johanna-healy",
    name: "Johanna Healy",
    scene: 2,
  },
  {
    url: "https://prod.spline.design/87Y2fh34QW6ohTU3/scene.splinecode",
    slug: "nam-nguyen",
    name: "Nam Nguyen",
    scene: 2,
  },

  {
    url: "https://prod.spline.design/hg7L0vXDbDCyrw7t/scene.splinecode",
    slug: "becky-dole",
    name: "Becky Dole",
    scene: 2,
  },

  {
    url: "https://prod.spline.design/GfSmUFbNSwORAZXd/scene.splinecode",
    slug: "meg-lewis",
    name: "Meg Lewis",
    scene: 2,
  },

  {
    url: "https://prod.spline.design/OmP5g2G6q3USr7lk/scene.splinecode",
    slug: "yev-belilovskiy",
    name: "Yev Belilovskiy",
    scene: 2,
  },

  {
    url: "https://prod.spline.design/p998Txf4bc59VFvu/scene.splinecode",
    slug: "martha-janicki",
    name: "Martha Janicki",
    scene: 2,
  },

  {
    url: "https://prod.spline.design/jh09aVRg5eC7Ktvg/scene.splinecode",
    slug: "mark-miller",
    name: "Mark Miller",
    scene: 2,
  },

  {
    url: "https://prod.spline.design/qpE7rxrWj1HJQXAU/scene.splinecode",
    slug: "marina-campana",
    name: "Marina Campana",
    scene: 2,
  },

  {
    url: "https://prod.spline.design/5tp5aaMGlGmAWToB/scene.splinecode",
    slug: "marc-leone",
    name: "Marc Leone",
    scene: 2,
  },

  {
    url: "https://prod.spline.design/glPQKZnxWH0M1bcq/scene.splinecode",
    slug: "brooke-bamford",
    name: "Brooke Bamford",
    scene: 2,
  },

  {
    url: "https://prod.spline.design/fR96I3aTvZaXTerB/scene.splinecode",
    slug: "bogdan-tirca",
    name: "Bogdan Tirca",
    scene: 2,
  },

  /******************************
   *        Group 3           *
   ******************************/

  {
    url: "https://prod.spline.design/RVPNNgPW9U253fQz/scene.splinecode",
    slug: "ali-sementilli",
    name: "Ali Sementilli",
    scene: 3,
  },
  {
    url: "https://prod.spline.design/15RsQrfwPnx0Re4N/scene.splinecode",
    slug: "amanda-grant",
    name: "Amanda Grant",
    scene: 3,
  },
  {
    url: "https://prod.spline.design/iyMqn1iAL9gwcCgP/scene.splinecode",
    slug: "arun-shyam",
    name: "Arun Shyam",
    scene: 3,
  },
  {
    url: "https://prod.spline.design/7SWPUUFfqyTOA5Dn/scene.splinecode",
    slug: "bassem-ali",
    name: "Bassem Ali",
    scene: 3,
  },
  {
    url: "https://prod.spline.design/yzSDdDZ3y3s4T08C/scene.splinecode",
    slug: "bryant-rockoff",
    name: "Bryant Rockoff",
    scene: 3,
  },
  {
    url: "https://prod.spline.design/8CBJj4TZjPerMBwn/scene.splinecode",
    slug: "dawnie-jefferson",
    name: "Dawnie Jefferson",
    scene: 3,
  },
  {
    url: "https://prod.spline.design/TxngRng0D04vS0Tk/scene.splinecode",
    slug: "giorgia-marenda",
    name: "Giorgia Marenda",
    scene: 3,
  },
  {
    url: "https://prod.spline.design/2y8MN454kqBHTMcw/scene.splinecode",
    slug: "jonny-mclaughlin",
    name: "Jonny McLaughlin",
    scene: 3,
  },
  {
    url: "https://prod.spline.design/Lbstnfpfqhxrq568/scene.splinecode",
    slug: "nat-maguire",
    name: "Nat Maguire",
    scene: 3,
  },

  {
    url: "https://prod.spline.design/ALSLJclp0zNXnUa6/scene.splinecode",
    slug: "christopher-hranj",
    name: "Christopher Hranj",
    scene: 3,
  },

  {
    url: "https://prod.spline.design/qQoMPWeEG29LTMlw/scene.splinecode",
    slug: "dan-burke",
    name: "Dan Burke",
    scene: 3,
  },

  {
    url: "https://prod.spline.design/eEtEwUijMqVqIEl7/scene.splinecode",
    slug: "caroline-huber",
    name: "Caroline Huber",
    scene: 3,
  },

  {
    url: "https://prod.spline.design/cABNbTGBO6Oc36VQ/scene.splinecode",
    slug: "chris-maier",
    name: "Chris Maier",
    scene: 3,
  },

  {
    url: "https://prod.spline.design/Prm1TdaRWf3YqsNI/scene.splinecode",
    slug: "chris-cubellis",
    name: "Chris Cubellis",
    scene: 3,
  },

  {
    url: "https://prod.spline.design/EHCQ36dZKoRqJzp0/scene.splinecode",
    slug: "mena-gonzalez",
    name: "Mena Gonzalez",
    scene: 3,
  },

  {
    url: "https://prod.spline.design/hTpKfBz-yAga7g3S/scene.splinecode",
    slug: "nick-hasty",
    name: "https://prod.spline.design/hTpKfBz-yAga7g3S/scene.splinecode",
    scene: 3,
  },

  {
    url: "https://prod.spline.design/7JD-6NCpBArug2uA/scene.splinecode",
    slug: "nicky-rojo",
    name: "Nicky Rojo",
    scene: 3,
  },

  {
    url: "https://prod.spline.design/IJQkdS9Rd7P76D3K/scene.splinecode",
    slug: "nikki-vinayan",
    name: "Nikki Vinayan",
    scene: 3,
  },

  {
    url: "https://prod.spline.design/FoQ1XKPx9OjPOggY/scene.splinecode",
    slug: "pankaj-khatkar",
    name: "Pankaj Khatkar",
    scene: 3,
  },

  {
    url: "https://prod.spline.design/yTSmHvawYOVmpMdi/scene.splinecode",
    slug: "utah-ingersoll",
    name: "Utah Ingersoll",
    scene: 3,
  },

  {
    url: "https://prod.spline.design/ZcTlj1BUhtwoidQ9/scene.splinecode",
    slug: "walter-menendez",
    name: "https://prod.spline.design/ZcTlj1BUhtwoidQ9/scene.splinecode",
    scene: 3,
  },

  /******************************
   *        Group 4           *
   ******************************/

  {
    url: "https://prod.spline.design/qb85Ta-W6B5eK3d9/scene.splinecode",
    slug: "amanda-murphree",
    name: "Amanda Murphree",
    scene: 4,
  },

  {
    url: "https://prod.spline.design/vOBxioEQ3Rt05jnj/scene.splinecode",
    slug: "collin-burger",
    name: "Collin Burger",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/JvgkmqD0rJGAJZkC/scene.splinecode",
    slug: "dani-newman",
    name: "Dani Newman",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/kV-FwdqzzVwjGwQG/scene.splinecode",
    slug: "jake-martella",
    name: "Jake Martella",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/hs49lECD1REoPpsG/scene.splinecode",
    slug: "jason-clarke",
    name: "Jason Clarke",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/PY9Xm2toup4M3wvV/scene.splinecode",
    slug: "katherine-puntiel",
    name: "Katherine Puntiel",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/FVdEdg5s07YiZeyl/scene.splinecode",
    slug: "raymond-wong",
    name: "Raymond Wong",
    scene: 4,
  },

  {
    url: "https://prod.spline.design/RS3offoHOsjY2XO8/scene.splinecode",
    slug: "dave-franzese",
    name: "Dave Franzese",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/Aw4fwxO6OFpGD7ps/scene.splinecode",
    slug: "david-carrillo",
    name: "David Carrillo",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/5hb0XvIpCBEM0IGf/scene.splinecode",
    slug: "debbie-aderinkomi",
    name: "Debbie Aderinkomi",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/cchhB7EmRTsf0urL/scene.splinecode",
    slug: "eric-goldfarb",
    name: "Eric Goldfarb",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/C7Xsh4k7f-M28QuN/scene.splinecode",
    slug: "erika-castro",
    name: "Erika Castro",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/J3lreZLKIk8LAPJc/scene.splinecode",
    slug: "parker-jackson",
    name: "Parker Jackson",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/5jaL5gEkzzQSxvPH/scene.splinecode",
    slug: "pete-cooke",
    name: "Pete Cooke",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/tUjAcdKpMsIVAUNZ/scene.splinecode",
    slug: "priya-shah",
    name: "Priyah Shah",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/WlbCN4N5Q3tfQPdJ/scene.splinecode",
    slug: "randy-shepherd",
    name: "Randy Shepherd",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/zVrmYKUmWslWwsT9/scene.splinecode",
    slug: "rebekah-huber",
    name: "Rebekah Huber",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/kjzR4eLGsMeyPwT0/scene.splinecode",
    slug: "richard-shen",
    name: "Richard Shen",
    scene: 4,
  },
  {
    url: "https://prod.spline.design/8OUiUfTYlXn5N9Iv/scene.splinecode",
    slug: "romy-saplicki",
    name: "Romy Saplicki",
    scene: 4,
  },

  /******************************
   *        Group 5           *
   ******************************/

  {
    url: "https://prod.spline.design/x60of59kjalaG4Lv/scene.splinecode",
    slug: "alex-chung",
    name: "Alex Chung",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/uxfoYRwfMaRJ6LzW/scene.splinecode",
    slug: "amanda-kaufmann",
    name: "Amanda Kaufmann",
    scene: 5,
  },

  {
    url: "https://prod.spline.design/X9Fohwa70k9p-AAf/scene.splinecode",
    slug: "gianni-ferullo",
    name: "Gianni Ferullo",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/dkogk8n6oxwz2z2F/scene.splinecode",
    slug: "jake-longoria",
    name: "Jake Longoria",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/dkogk8n6oxwz2z2F/scene.splinecode",
    slug: "jess-maldonado",
    name: "Jess Maldonado",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/TPfgyVun7rIv9KfR/scene.splinecode",
    slug: "maria-rodriguez",
    name: "Maria Rodriguez",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/c2BBPuqkd100H6oO/scene.splinecode",
    slug: "nick-santaniello",
    name: "Nick Santaniello",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/Y6Xavp1-724x62-s/scene.splinecode",
    slug: "ralph-bishop",
    name: "Ralph Bishop",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/N-UMqk9ZbJu4DVld/scene.splinecode",
    slug: "sixuan-liu",
    name: "Sixuan Liu",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/xiyBVhxaC1uj-H6W/scene.splinecode",
    slug: "eugene-kong",
    name: "Eugene Kong",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/ss94AZMFoOjIuSr0/scene.splinecode",
    slug: "felipe-menezes",
    name: "Felipe Menezes",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/269KvXSAeI6POVTE/scene.splinecode",
    slug: "gregg-valentine",
    name: "Gregg Valentine",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/a2MW6uM54rDpPm-g/scene.splinecode",
    slug: "isaiah-lawrence",
    name: "Isaiah Lawrence",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/6SMcpcoR1lTmQ7gK/scene.splinecode",
    slug: "sabrina-pacheco",
    name: "Sabrina Pacheco",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/BlMoartav2GTPGmP/scene.splinecode",
    slug: "sam-mantell",
    name: "Sam Mantell",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/4Jpp5iefBuY3ue7y/scene.splinecode",
    slug: "sazan-pasori",
    name: "Sazan Pasori",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/1IVimMmkddSwq2Tz/scene.splinecode",
    slug: "sean-quigley",
    name: "Sean Quigley",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/AIKa1LkNY24GbSyi/scene.splinecode",
    slug: "sepp-dasbach",
    name: "Sepp Dashbach",
    scene: 5,
  },
  {
    url: "https://prod.spline.design/H7K3xZppW9hgphwU/scene.splinecode",
    slug: "stacy-rizzetta",
    name: "Stacy Rizzeta",
    scene: 5,
  },

  /******************************
   *        Group 6           *
   ******************************/
  {
    url: "https://prod.spline.design/ZmXOY9WAH2mIfMX3/scene.splinecode",
    slug: "alex-anderson",
    name: "Alex Anderson",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/2JeG6JrY5drKoFaH/scene.splinecode",
    slug: "anthony-berteaux",
    name: "Anthony Berteaux",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/u5Flrl1YMvWh5eeL/scene.splinecode",
    slug: "brad-zeff",
    name: "Brad Zeff",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/ntypgG0Hsp7Yxm4G/scene.splinecode",
    slug: "cat-powell",
    name: "Cat Powell",
    scene: 6,
  },

  {
    url: "https://prod.spline.design/OMNpnfEQuKazjRbg/scene.splinecode",
    slug: "hope-sincere",
    name: "Hope Sincere",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/96l-l4wCNH0CYckk/scene.splinecode",
    slug: "leroy-patterson",
    name: "Leroy Patterson",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/vdZ036zmypZVdKfK/scene.splinecode",
    slug: "jacob-graff",
    name: "Jacob Graff",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/4eCOAE1KWZHKQO7y/scene.splinecode",
    slug: "jake-walker",
    name: "Jake Walker",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/K5BXtJWUFUbHBTwr/scene.splinecode",
    slug: "jason-stein",
    name: "Jason Stein",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/K5BXtJWUFUbHBTwr/scene.splinecode",
    slug: "lydia-getachew",
    name: "Lydia Getachew",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/5pFBjgxfV7HxdcCk/scene.splinecode",
    slug: "jen-rubnitz",
    name: "Jen Rubnitz",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/5pFBjgxfV7HxdcCk/scene.splinecode",
    slug: "stephanie-weber",
    name: "Stephabie Weber",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/PsmdgdDudC0uurC2/scene.splinecode",
    slug: "tiff-vazquez",
    name: "Tiff Vazquez",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/atEhdYW5VKn9Kwfh/scene.splinecode",
    slug: "tj-freda",
    name: "TJ Freda",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/IAyWS6VEYs3UECXx/scene.splinecode",
    slug: "tomas-ferraro",
    name: "Tomas Ferraro",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/KPG3KzTylU6DuZNW/scene.splinecode",
    slug: "tyler-menzel",
    name: "Tyler Menzel",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/VWr8fhPyGttRixEf/scene.splinecode",
    slug: "zach-brown",
    name: "Zach Brown",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/Wl0eBxikCgKuXmSH/scene.splinecode",
    slug: "zack-kantor",
    name: "Zack Kantor",
    scene: 6,
  },
  {
    url: "https://prod.spline.design/NweqNc-JPWiW2GrS/scene.splinecode",
    slug: "pamela-thomas",
    name: "Pamela Thomas",
    scene: 6,
  },
];
